import AuthenticationService from "application/modules/authentication/AuthenticationService";
import layouts from "globals/layouts";

const DASHBOARD_CONTROLLER_PAGE = (description) => ({
  key: "dashboard.controller",
  name: "dashboardController",
  url: "/app/dashboardController/home",
  description,
});

const MENU_DASHBOARD_PAGE = {
  key: "menu-dashboard",
  name: "Menu's Dashboard",
  url: "/app/menu-dashboard/home",
  description: "Menu Dashboard",
};

const MISSED_CALLS_PAGE = {
  key: "uc.missed-calls",
  name: "Missed calls",
  url: "home/app/uc/missed-calls",
  description: "Missed incoming calls",
};

// Ordered landing rules for post-login/default landing, the persisted refresh
// outcome, and the sidebar `auth-default` action. First match wins. Seeded in
// the exact priority order of the ladder this replaces (see
// DefaultAuthorisedPage), so a mixed-role holder still resolves through
// whichever rule their role set reached first today. The four explicit
// legacy no-page roles (Hotel, KM Admin, Department Head, EAMS) are seeded
// as `noPage: true` sentinels at their original ladder positions rather than
// hoisted ahead of every other rule - hoisting them would change landing for
// any higher-priority role combined with one of the four.
const roleLandingConfig = [
  {
    match: () =>
      AuthenticationService.allowAdminMenus() &&
      !AuthenticationService.allowRailwayDispatcher(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE(""),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () =>
      AuthenticationService.allowActiveAlerts() ||
      AuthenticationService.allowOperatorSupervisor() ||
      AuthenticationService.allowACDSupervisor(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE(""),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    // Explicit legacy no-page role - kept at allowhmsAdminMenus()'s original
    // ladder position, not hoisted ahead of admin/active-alert.
    match: () => AuthenticationService.allowhmsAdminMenus(),
    noPage: true,
  },
  {
    // Explicit legacy no-page role - kept at allowkmAdminMenus()'s original
    // ladder position.
    match: () => AuthenticationService.allowkmAdminMenus(),
    noPage: true,
  },
  {
    match: () =>
      AuthenticationService.allownmsMenus() ||
      AuthenticationService.allownmsAdminMenus() ||
      (AuthenticationService.allownmsViewerMenus() &&
        !AuthenticationService.allowRailwayDispatcher()),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowkanAdminMenus(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowsurakshaMenus(),
    hasDashboard: false,
    page: {
      key: "nms.maps",
      name: "Suraksha",
      url: "home/app/nms/map",
      description: "MAP",
    },
  },
  {
    // Contains ROLE_USERS - kept at allowUCMenus()'s original position,
    // ahead of customuc/picker/codeblue/billing. Mixed UC sets reaching
    // this rule intentionally move from Menu Dashboard to Missed Calls
    // (approved scope change); a ROLE_USERS + ROLE_PICKER set also resolves
    // here, same as it hit allowUCMenus() first today.
    match: () => AuthenticationService.hasNormalizedRole("ROLE_USERS"),
    hasDashboard: false,
    page: MISSED_CALLS_PAGE,
  },
  {
    match: () => AuthenticationService.allowCustomucMenu(),
    hasDashboard: false,
    page: MENU_DASHBOARD_PAGE,
  },
  {
    // Exact ROLE_PICKER only - kept at allowVoicePickerMenus()'s original
    // position, ahead of the contains-ROLE_PICKER rule below, so
    // first-match-wins sends picker-only users to Voice Picker while every
    // other ROLE_PICKER superset falls through to the next rule.
    match: () => AuthenticationService.hasExactNormalizedRoles(["ROLE_PICKER"]),
    hasDashboard: false,
    page: {
      key: "backuprecordingfile",
      name: "Voice Picker",
      url: "home/app/configurations/new-voice-picker",
      description: "Backup and Download ",
    },
  },
  {
    // Preserves today's allowVoicePickerMenus() landing for every other
    // ROLE_PICKER superset not caught by the exact rule above.
    match: () => AuthenticationService.hasNormalizedRole("ROLE_PICKER"),
    hasDashboard: false,
    page: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowCodeBlueViewerMenus(),
    hasDashboard: false,
    page: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowBillingMenus(),
    hasDashboard: false,
    page: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowOperatorAdminMenus(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowAgentMenus(),
    hasDashboard: false,
    page: {
      key: "agentDashboard",
      name: "Agent Dashboard",
      url: "home/app/agent/dashboard",
      description: "Agent Dashboard",
    },
  },
  {
    match: () => AuthenticationService.allowDashboardConfigMenus(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowCallcenterTabMenus(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowGroupAdmin(),
    hasDashboard: false,
    page: {
      key: "menu-dashboard",
      name: "Menu's Dashboard",
      url: "home/app/home",
      description: "Menu Dashboard",
    },
  },
  {
    match: () => AuthenticationService.allowUCConferenceMenus(),
    hasDashboard: false,
    page: {
      key: "uc.conference.calendar",
      name: "Conference Calendar",
      url: "home/app/Conference Calendar",
      description: "Conference Calendar",
    },
  },
  {
    match: () => AuthenticationService.allowPAMenu(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowEngineerMenu(),
    hasDashboard: false,
    page: {
      key: "PendingComplaintEngineer",
      name: "Pending Complaints with Engineer",
      url: "home/app/cms-reports/pending-complaint-with-engineer",
      description: "Pending Complaint with Engineer",
    },
  },
  {
    match: () => AuthenticationService.allowRailwayDispatcher(),
    hasDashboard: false,
    page: {
      key: "nms.maps",
      name: "Suraksha",
      url: "home/app/map",
      description: "MAP",
    },
  },
  {
    match: () => AuthenticationService.allowMCXDispatcher(),
    hasDashboard: false,
    page: {
      key: "nms.maps",
      name: "Suraksha",
      url: "home/app/map",
      description: "MAP",
    },
  },
  {
    // Explicit legacy no-page role - kept at allowDepartmentHeadMenu()'s
    // original ladder position, behind railway/MCX and ahead of taskUser.
    match: () => AuthenticationService.allowDepartmentHeadMenu(),
    noPage: true,
  },
  {
    match: () => AuthenticationService.allowTaskUserManager(),
    hasDashboard: false,
    page: {
      key: "userTask",
      name: "User Control Task Manager",
      url: "home/app/taskManagementSystem",
      description: "User View Task Details, and update their status",
    },
  },
  {
    match: () => AuthenticationService.allowTaskManager(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    match: () => AuthenticationService.allowApollo(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    // Explicit legacy no-page role - kept at allowEamsMenu()'s original
    // ladder position, behind apollo and ahead of managerMenus. Preserves
    // the original quirk of mutating activePage's fields without
    // dispatching (renderComponent applies silentPage, then returns null).
    match: () => AuthenticationService.allowEamsMenu(),
    noPage: true,
    silentPage: {
      key: "menu-dashboard",
      name: "Menu's Dashboard",
      url: "/app/menudashboard/home",
      description: "Menu Dashboard",
    },
  },
  {
    match: () => AuthenticationService.allowManagerMenus(),
    hasDashboard: true,
    page: DASHBOARD_CONTROLLER_PAGE("Dashboard Controller"),
    fallbackPage: MENU_DASHBOARD_PAGE,
  },
  {
    // Terminal fallback - matches whatever role set reaches this point.
    match: () => true,
    hasDashboard: false,
    page: MISSED_CALLS_PAGE,
  },
];

function isRegisteredPageId(pageId) {
  return layouts.some((layout) => layout.pageId === pageId);
}

function toRegisteredPage(page) {
  if (page && isRegisteredPageId(page.key)) {
    return page;
  }
  return MENU_DASHBOARD_PAGE;
}

// Scans roleLandingConfig in order and returns the first matching rule's
// resolved (registered-layout-validated) landing. Invalid, missing, or
// self-referencing configured keys safely resolve to Menu Dashboard.
// A matched `noPage` rule returns `{ noPage: true }` (plus `silentPage` for
// EAMS's mutate-without-dispatch quirk) instead of a dispatchable page.
function resolveRoleLanding() {
  for (const rule of roleLandingConfig) {
    if (rule.match()) {
      if (rule.noPage) {
        return { noPage: true, silentPage: rule.silentPage || null };
      }
      return {
        noPage: false,
        hasDashboard: !!rule.hasDashboard,
        page: toRegisteredPage(rule.page),
        fallbackPage: rule.hasDashboard
          ? toRegisteredPage(rule.fallbackPage || MENU_DASHBOARD_PAGE)
          : null,
      };
    }
  }
  return {
    noPage: false,
    hasDashboard: false,
    page: MENU_DASHBOARD_PAGE,
    fallbackPage: null,
  };
}

export { roleLandingConfig, resolveRoleLanding };
